import { action, observable } from 'mobx';
import { FacilityCreateForm } from 'application/facility/forms';
import { BaseEditViewStore } from 'core/stores';
import {applicationContext} from 'core/utils';
import {FacilityService} from 'application/facility/services';

@applicationContext
class FacilityCreateViewStore extends BaseEditViewStore {
    @observable accessor missingItems = null;
    @observable accessor facilitiesNeedingPayers = null;
    constructor(rootStore) {
        const service = new FacilityService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'file',
            Form: FacilityCreateForm,
            actions: () => {
                return {
                    create: async () => {
                        const file = this.form.fields.get("file").files[0];
                        return await service.upload({file: file});
                    }
                }
            },
            FormClass: FacilityCreateForm,
        });
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        this.missingItems = null;
        this.facilitiesNeedingPayers = null;
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            const facilitiesNeedingPayers = await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            if (facilitiesNeedingPayers && facilitiesNeedingPayers.length) {
                this.facilitiesNeedingPayers = facilitiesNeedingPayers;
                this.rootStore.notificationStore.success('Facilities updated successfully.');
                return;
            }

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success('Facilities updated successfully.'), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            if(err.data && err.data.Message == "Missing Items")
            {
                this.missingItems = err.data.Data;
                this.rootStore.notificationStore.error(err.data.Message);
            }
            else
            {
                this.rootStore.notificationStore.error(err && err.data && err.data.Message ? err.data.Message : 'Error occured while trying to update the facilities.');
            }
        }
    }

    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
}

export default FacilityCreateViewStore;
